import React from 'react';

import { AddAutomationButton } from './add-automation-button';
import { AutomationTimelineTitle } from './automation-timeline-title';

import { CreatableApplicantAutomationTypes } from '../../utils/applicant-automation-communication-types';
import { AutomationsByTriggerDictionary } from '../../utils/applicant-automation-display-utils';

type InputProps = {
  org: Org;
  editingForJob?: Job;
  parentAutomationsForSection?: AutomationsByTriggerDictionary;

  title?: string;
  triggerType:
    | 'applicant'
    | CreatableApplicantAutomationTypes
    | StartDateTriggeredCommunicationTriggerType;
  section?: ApplicantAutomationSection;
  isFirst?: boolean;
  isLast?: boolean;
  interval?: EmployeeAutomationSendInterval;
};

export const AutomationTimelineTitleCreate = (props: InputProps) => {
  const {
    org,
    editingForJob,
    parentAutomationsForSection,
    title,
    triggerType,
    interval,
    section,
    isFirst,
    isLast,
  } = props;

  return (
    <AutomationTimelineTitle
      title={
        <div>
          {title}
          <AddAutomationButton
            className={title ? 'u-margin-left-md' : ''}
            variant={isLast ? 'large' : 'medium'}
            org={org}
            triggerType={triggerType}
            section={section}
            editingForJob={editingForJob}
            parentAutomationsForSection={parentAutomationsForSection}
            interval={interval}
          />
        </div>
      }
      icon={
        <AddAutomationButton
          variant="small"
          org={org}
          triggerType={triggerType}
          section={section}
          editingForJob={editingForJob}
          parentAutomationsForSection={parentAutomationsForSection}
          interval={interval}
        />
      }
      isFirst={isFirst}
      isLast={isLast}
    />
  );
};
